import { CartLinesUpdateEvent } from '@shopify/events';
import { CartItemsComponent } from './component-cart-items.js';

class CartUpsell extends HTMLElement {
  static busy = false;

  connectedCallback() {
    this.addEventListener('click', this.add);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.add);
  }

  add = async (event) => {
    const button = event.target.closest('[data-upsell-add]');
    if (!button || !this.contains(button) || CartUpsell.busy) return;
    CartUpsell.busy = true;
    const error = this.querySelector('.ml-cart-upsell__error');
    error.hidden = true;
    const buttons = this.querySelectorAll('[data-upsell-add]');
    buttons.forEach((control) => { control.disabled = true; });
    button.setAttribute('aria-busy', 'true');
    const root = window.Shopify?.routes?.root || '/';
    let added = false;
    try {
      await Promise.allSettled(CartItemsComponent.pendingQuantityUpdates);
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.upsellAdd), quantity: 1 }],
          sections: 'cart-drawer-section',
          sections_url: window.location.pathname,
        }),
      });
      const result = await response.json();
      if (!response.ok) throw new Error('add');
      added = true;
      const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!cartResponse.ok) throw new Error('refresh');
      const cart = await cartResponse.json();
      const promise = Promise.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { sections: result.sections, items: cart.items, itemCount: cart.item_count, source: 'ml-cart-upsell', didError: false },
      });
      document.dispatchEvent(new CartLinesUpdateEvent({
        action: 'add', context: 'cart',
        lines: [{ merchandiseId: String(button.dataset.upsellAdd), quantity: 1 }],
        promise,
      }));
    } catch {
      if (added) {
        document.dispatchEvent(new CartLinesUpdateEvent({
          action: 'update', context: 'cart', lines: [],
          promise: Promise.resolve({ detail: { source: 'ml-cart-upsell', didError: false } }),
        }));
        button.hidden = true;
      } else {
        error.textContent = this.dataset.error;
        error.hidden = false;
      }
    } finally {
      CartUpsell.busy = false;
      buttons.forEach((control) => { control.disabled = false; });
      button.removeAttribute('aria-busy');
    }
  };
}

if (!customElements.get('ml-cart-upsell')) customElements.define('ml-cart-upsell', CartUpsell);
